import React, { useEffect, useState } from 'react'
import DefaultSEO from '../components/DefaultSEO'
import { policyService } from '../services/policyService'
import { Loader2 } from 'lucide-react'

const CancellationPolicyPage = () => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const data = await policyService.getCancellationPolicy();
        setPolicy(data);
      } catch (err) {
        console.error('Error fetching cancellation policy:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPolicy();
  }, []);

  if (loading) {
    return (
      <div className="container py-5 d-flex justify-content-center align-items-center min-vh-100">
        <Loader2 className="animate-spin text-primary" size={48} />
      </div>
    );
  }

  return (
    <>
      <DefaultSEO title="Cancellation Policy | ZoyoTrip" description="Read our cancellation and refund policies before booking your stay." />
      <div className="container py-5" style={{ maxWidth: "900px" }}>
        <h1 className="fw-bolder display-5 mb-5 text-center text-primary" style={{ fontSize: '3rem' }}>{policy?.title || 'Cancellation & Refund Policy'}</h1>

        {policy?.content ? (
          <div className="policy-content" dangerouslySetInnerHTML={{ __html: policy.content }} />
        ) : (
          <p className="text-center text-muted">No policy available at the moment.</p>
        )}

        <style jsx>{`
          .animate-spin { animation: spin 1s linear infinite; }
          @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
          .policy-content h4 { color: #212529; font-weight: 600; margin-top: 2rem; margin-bottom: 1rem; }
          .policy-content p, .policy-content li { color: #6c757d; line-height: 1.6; }
          .policy-content ul { padding-left: 1.5rem; }
        `}</style>
      </div>
    </>
  )
}

export default CancellationPolicyPage
